import React from "react";
import "./Dropzone.scss";
import loadImg from "./assets/loading-truck.png";
import { useTranslation } from "react-i18next";

export const LoadTruck = () => {
  const { t } = useTranslation("common");

  return (
    <div className={"dropzone"}>
      <img src={loadImg} alt="load truck" height={150} />
      <p>{t("Put item in truck")}</p>
    </div>
  );
};
